import { defineMessages, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

const messages = defineMessages({
  bricsLogo: {
    id: 'BRICS Logo',
    defaultMessage: 'BRICS Logo',
  },
  backToHome: {
    id: 'Back to home',
    defaultMessage: 'Back to home',
  },
});

const LogoLink = ({ href, title, nolink, className, image }) => {
  const intl = useIntl();

  // const content = (
  //   <Image src={image} alt={intl.formatMessage(messages.bricsLogo)} />
  // );
  const content = image;

  if (nolink) {
    return <span className={className}>{content}</span>;
  }

  return (
    <Link
      className={className}
      to={href || '/'}
      title={title || intl.formatMessage(messages.backToHome)}
    >
      {content}
    </Link>
  );
};

export default LogoLink;
